import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiTwitter, FiLinkedin, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const styles = {
    footer: {
      background: '#1a3a5c',
      color: 'white',
      padding: '60px 0 30px'
    },
    container: {
      maxWidth: '1280px',
      margin: '0 auto',
      padding: '0 24px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '40px',
      marginBottom: '40px'
    },
    column: {
      display: 'flex',
      flexDirection: 'column'
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '16px'
    },
    logoIcon: {
      width: '36px',
      height: '36px',
      background: '#d4a5a5',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#1a3a5c',
      fontWeight: '700',
      fontSize: '1.25rem'
    },
    logoText: {
      fontWeight: '700',
      fontSize: '1.25rem'
    },
    tagline: {
      color: '#d4a5a5',
      fontSize: '0.875rem',
      fontStyle: 'italic',
      marginBottom: '12px'
    },
    description: {
      color: 'rgba(255,255,255,0.7)',
      fontSize: '0.9375rem',
      lineHeight: '1.6',
      marginBottom: '20px'
    },
    social: {
      display: 'flex',
      gap: '12px'
    },
    socialIcon: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      transition: 'background 0.2s ease',
      cursor: 'pointer'
    },
    heading: {
      fontWeight: '600',
      fontSize: '1rem',
      marginBottom: '20px',
      color: 'white'
    },
    links: {
      listStyle: 'none',
      padding: 0,
      margin: 0
    },
    link: {
      color: 'rgba(255,255,255,0.7)',
      textDecoration: 'none',
      display: 'block',
      padding: '8px 0',
      transition: 'color 0.2s ease',
      fontSize: '0.9375rem'
    },
    contactItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      marginBottom: '16px',
      color: 'rgba(255,255,255,0.7)',
      fontSize: '0.9375rem'
    },
    contactIcon: {
      color: '#d4a5a5',
      marginTop: '3px'
    },
    divider: {
      height: '1px',
      background: 'rgba(255,255,255,0.1)',
      margin: '0 0 24px'
    },
    bottom: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '16px'
    },
    copyright: {
      color: 'rgba(255,255,255,0.5)',
      fontSize: '0.875rem'
    },
    bottomLinks: {
      display: 'flex',
      gap: '24px'
    },
    bottomLink: {
      color: 'rgba(255,255,255,0.5)',
      textDecoration: 'none',
      fontSize: '0.875rem',
      transition: 'color 0.2s ease'
    }
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.grid} className="footer-grid">
          {/* Column 1 - About */}
          <div style={styles.column}>
            <div style={styles.logo}>
              <span style={styles.logoIcon}>K</span>
              <span style={styles.logoText}>Kasbia Stays</span>
            </div>
            <p style={styles.tagline}>Your Home Away From Home</p>
            <p style={styles.description}>
              Premium serviced accommodation in Gravesend.
              Perfect for contractors, re-locaters & short stay holidays.
            </p>
            <div style={styles.social}>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" style={styles.socialIcon}>
                <FiFacebook />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" style={styles.socialIcon}>
                <FiInstagram />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" style={styles.socialIcon}>
                <FiTwitter />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" style={styles.socialIcon}>
                <FiLinkedin />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div style={styles.column}>
            <h4 style={styles.heading}>Quick Links</h4>
            <ul style={styles.links}>
              <li><Link to="/apartments" style={styles.link}>All Apartments</Link></li>
              <li><Link to="/locations" style={styles.link}>Locations</Link></li>
              <li><Link to="/about" style={styles.link}>About Us</Link></li>
              <li><Link to="/contact" style={styles.link}>Contact</Link></li>
              <li><Link to="/faq" style={styles.link}>FAQ</Link></li>
            </ul>
          </div>

          {/* Column 3 - Support */}
          <div style={styles.column}>
            <h4 style={styles.heading}>Support</h4>
            <ul style={styles.links}>
              <li><Link to="/faq" style={styles.link}>Help Center</Link></li>
              <li><Link to="/terms" style={styles.link}>Terms of Service</Link></li>
              <li><Link to="/privacy" style={styles.link}>Privacy Policy</Link></li>
              <li><Link to="/contact" style={styles.link}>Contact Support</Link></li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div style={styles.column}>
            <h4 style={styles.heading}>Contact Us</h4>
            <div style={styles.contactItem}>
              <FiMapPin style={styles.contactIcon} />
              <span>Gravesend, Kent, UK</span>
            </div>
            <div style={styles.contactItem}>
              <FiPhone style={styles.contactIcon} />
              <div>
                <div>07577 952535</div>
                <div>07715 512267</div>
                <div>07853 083370</div>
              </div>
            </div>
            <div style={styles.contactItem}>
              <FiMail style={styles.contactIcon} />
              <span>info@kasbiastays.co.uk</span>
            </div>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.bottom}>
          <p style={styles.copyright}>
            &copy; {currentYear} Kasbia Stays. All rights reserved.
          </p>
          <div style={styles.bottomLinks}>
            <Link to="/privacy" style={styles.bottomLink}>Privacy</Link>
            <Link to="/terms" style={styles.bottomLink}>Terms</Link>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 992px) {
          .footer-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 576px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
